import Vue from 'vue';
import {API_ROOT} from '../config'

const customActions = {
  current: {method: 'GET', url: API_ROOT + 'price-list/current'}
};

export default Vue.resource(API_ROOT + 'price-list{/id}', {}, customActions);



// WEBPACK FOOTER //
// ./client/resources/priceListResource.js